import ActionType from './ActionType';

/* Action 생성자 */
export const selectNavMenu = (selectedMenu) => {
  return {
    type: ActionType.SELECT_NAV_MENU,
    selectedMenu
  }
};

export const selectDate = (selectedDate) => {
  return {
    type: ActionType.SELECT_DATE,
    selectedDate
  }
}

export const setChannelList = (channelList) => {
  return {
    type: ActionType.SET_CHANNEL_LIST,
    channelList
  }
}


export const createVideo = (videoItem) => {
  return {
    type: ActionType.CREATE_VIDEO,
    videoItem
  }
}

export const updateSearchCondition = (searchCondition) => {
  return {
    type: ActionType.UPDATE_SEARCH_CONDITION,
    searchCondition
  }
}
export const updateActiveChannelListIndex = (chListIndex) => {
  return {
    type: ActionType.UPDATE_CHANNEL_LIST_INDEX,
    activeChannelListIndex: chListIndex
  }
}
export const showVideoFlag = (videoFlag) => {
  return {
    type: ActionType.SHOW_VIDEO,
    videoFlag
  }
}

export const showDetailFlag = (detailFlag, detailInfo = '') => {
  return {
    type: ActionType.SHOW_DETAIL,
    detailFlag,
    detailInfo
  }
}


export const showModalFlag = (modalFlag) => {
  return {
    type: ActionType.SHOW_MODAL,
    modalFlag
  }
}

export const showUserFlag = (userFlag, userInfoType = '') => {
  return {
    type: ActionType.SHOW_USER,
    userFlag,
    userInfoType
  }
}

export const setVideoSoundItem = (activeVideo) => {
  return {
    type: ActionType.SET_VIDEO_SOUND_ITEM,
    activeVideo
  }
}

export const setVideoType = (activeVideoType) => {
  return {
    type: ActionType.SET_VIDEO_TYPE,
    activeVideoType
  }
}

export const updateLogCondition = (logCondition) => {
  return {
    type: ActionType.UPDATE_LOG_CONDITION,
    logCondition
  }
}

export const setMarkInTC = (markInInfo) => {
  return {
    type: ActionType.SET_MARKIN_TC,
    markInInfo
  }
}

export const setMarkOutTC = (markOutInfo) => {
  return {
    type: ActionType.SET_MARKOUT_TC,
    markOutInfo
  }
}

export const setNotice = (flag, state, content) => {
  return {
    type: ActionType.SET_NOTICE,
    flag, state, content
  }
}






// WEBPACK FOOTER //
// ./src/actions/index.js